import axios from 'axios';

// Use relative URLs to leverage the proxy configured in package.json
// This ensures cookies are sent correctly (same-origin)
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Redirect to login on session expiry
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/')) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API for Travel Agency
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  verifySession: () => api.get('/auth/verify'),

  // Activation flow
  verifyActivationCode: (activationCode, email) =>
    api.post('/auth/verify-activation', { activationCode, email }),
  setPassword: (token, password) =>
    api.post('/auth/set-password', { token, password })
};

// Status Center API
export const statusCenterAPI = {
  getApplications: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    return api.get(`/status-center/applications?${queryParams.toString()}`);
  },
  getStats: () => api.get('/status-center/stats'),
  getApplicationById: (id) => api.get(`/status-center/applications/${id}`),
  updateStatus: (id, data) => api.put(`/status-center/applications/${id}/status`, data)
};

// Agent Application API
export const agentApplicationAPI = {
  findUser: (data) => api.post('/agent-applications/find-user', data),
  getCountries: () => api.get('/agent-applications/countries'),
  getVisaConfigs: (countryId) => api.get(`/agent-applications/visa-configs?countryId=${countryId}`),
  getRequiredDocs: (visaConfigId) => api.get(`/agent-applications/required-docs?visaConfigId=${visaConfigId}`),
  extractDocument: (formData) => api.post('/agent-applications/extract-document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  create: (data) => api.post('/agent-applications/create', data),
  getById: (id) => api.get(`/agent-applications/${id}`),
  uploadDocument: (id, formData) => api.post(`/agent-applications/${id}/upload-document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  confirmDocument: (id, data) => api.post(`/agent-applications/${id}/confirm-document`, data),
  submit: (id, data) => api.post(`/agent-applications/${id}/submit`, data)
};

export default api;
